import { State } from "@/store/modules/user/index";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";

const getUser = (state: State): UserInterface | null => {
  return state.user;
};

const getSpaceUser = (state: State): SpaceUserInterface | null => {
  return state.spaceUser;
};

const getPreviousStatus = (state: State): any | null => {
  return state.previousStatus;
};

const getPosition = (state: State): any | null => {
  return state.position;
};

const getConfig = (state: State): any | null => {
  return state.config;
};

const getConfigSilenceNotification = (state: State): any | null => {
  return state.configSilenceNotification;
};

const getGameKiller = (state: State): any => {
  return state.isKiller;
};

const getIsOnline = (state: State): boolean => {
  return state.isOnline;
};

export default {
  getUser,
  getSpaceUser,
  getPreviousStatus,
  getPosition,
  getConfig,
  getConfigSilenceNotification,
  getGameKiller,
  getIsOnline,
};
